export interface IProgressCircleOptions {
    containerSize?: number;
    strokeWidth?: number;
    radius?: number;
    progressClass?: string;
    progress: number;
    icon?: string;
}

export const DEFAULT_STROKE_NO_ICON = 14;
export const DEFAULT_STROKE_ICON = 10;
export const DEFAULT_RADIUS_NO_ICON = 30;
export const DEFAULT_RADIUS_ICON = 40;

export default class ProgressCircle {

    createSvgCircle(options: IProgressCircleOptions) {
        let containerSize = options.containerSize || 100;
        let strokeWidth = options.strokeWidth || (options.icon ? DEFAULT_STROKE_ICON : DEFAULT_STROKE_NO_ICON);
        let borderWidth = strokeWidth;
        let radius = options.radius || (options.icon ? DEFAULT_RADIUS_ICON : DEFAULT_RADIUS_NO_ICON);
        let outerRadius = radius + borderWidth;
        let progressClass = options.progressClass || "";
        let circumference = radius * 2 * Math.PI;
        let progress = options.progress;
        let containerHalf = (containerSize / 2) + (borderWidth / 2);

        let icon = "";
        if (options.icon) {
            let midPoint = (containerHalf) - 14;
            icon = `<svg class="svgIcon biggest progress-icon" style="top:${ midPoint }px; left:${ midPoint }px;"role="img" aria-label="Progress bar icon">
                        <use xlink:href="#${ options.icon }"></use>
                    </svg>`;
        }

        const progressRingTopOffset = `style="top:${ borderWidth }px"`;
        const progressRingBackground = `<svg
            class="progress-ring ring-background"
            width="${ containerSize + borderWidth }"
            height="${ containerSize + borderWidth }">
            <circle
                class="progress-ring__circle"
                r="${ outerRadius }"
                cx="${ containerHalf }"
                cy="${ containerHalf }"/>
        </svg>`;
        return `<div class="progress-circle-container ${ progressClass }">
                    ${ icon }
                    <svg
                        class="progress-ring ring-progress"
                        ${ progressRingTopOffset }
                        width="${ containerSize }"
                        height="${ containerSize }">
                        <circle
                            class="progress-ring__circle"
                            stroke-dasharray="${ circumference }"
                            stroke-dashoffset="${ progress * circumference }"
                            stroke-width="${ strokeWidth + 2 }"
                            fill="transparent"
                            r="${ radius }"
                            cx="${ containerHalf }"
                            cy="${ containerHalf }"/>
                    </svg>

                    <svg
                        class="progress-ring ring-base ${ progressClass }"
                        ${ progressRingTopOffset }
                        width="${ containerSize }"
                        height="${ containerSize }">
                        <circle
                            class="progress-ring__circle"
                            stroke-width="${ strokeWidth }"
                            fill="transparent"
                            r="${ radius }"
                            cx="${ containerHalf }"
                            cy="${ containerHalf }"/>
                    </svg>

                    ${ progressRingBackground }
                </div>`;
    }
}